import { useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import AllianceLogo from "images/Alliance-Logo-500.png";
import BCDLogo from "images/BCD-Logo.png";
import { getInitialSearchDto } from "models/SearchTransactionDto";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { setSearchDto } from "reducers/dto.slice";
import { getCustomerById } from "services/customer.service";

const OemAdminDash = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const oemCustomers = useAppSelector(state => state.customers.oemDropDown);

    const dispatch = useAppDispatch();

    const handleChange = (customerId: string) => {
        dispatch(setSearchDto(getInitialSearchDto(customerId)));
        dispatch(getCustomerById(customerId));
    }

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
        <>
            <div className="text-center d-flex flex-column justify-content-center align-items-center mt-5">
                <img src={BCDLogo} className="rounded img-fluid" alt="bcdlogo" />
                <img src={AllianceLogo} className="rounded mt-5" width="300" alt="alliancelogo" />
            </div>
            <Dropdown className="d-flex justify-content-center align-items-center mt-5" isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color='primary' className="fw-bold fs-5 bcd-admin-toggle" caret>
                    Customers
                </DropdownToggle>
                <DropdownMenu className="bcd-dropdown-scroll">
                    {oemCustomers.map((c, index) => {
                        return (
                            <div key={c.id}>
                                <DropdownItem className='link-primary' key={c.id} onClick={() => handleChange(c.id)}>{c.display}</DropdownItem>
                                {index < oemCustomers.length - 1 && <DropdownItem divider />}
                            </div>
                        );
                    })
                    }
                </DropdownMenu>
            </Dropdown>
            <div className="d-flex justify-content-center align-items-center mt-5 flex-column">
                <h3> Welcome Allies! </h3>
                <h4>Select an OEM customer to get started.</h4>
            </div>
        </>
    );
}

export default OemAdminDash;
